import Offcanvas from 'react-bootstrap/Offcanvas';
import { OffcanvasHeaderProps } from 'react-bootstrap/esm/OffcanvasHeader';
import { IDrawerStyles, useDrawerStyles } from "..";

export interface DrawerFooterProps extends OffcanvasHeaderProps {
    controlStyles?: IDrawerStyles | undefined;
}

const ComponentProps = (props: DrawerFooterProps): OffcanvasHeaderProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;

    return componentProps;
}

export const DrawerFooter: React.FC<DrawerFooterProps> = (props) => {  
    const styles: IDrawerStyles = props.controlStyles ?? useDrawerStyles();
    const className: string = props.className ?? "border-top mx-2 mt-2 px-1";

    return (
        <Offcanvas.Header {...ComponentProps(props)} className={className} style={{ ...styles.container, ...props.style }} />
    );
};